module.exports = __webpack_public_path__ + "img/banner.a2122552.png";